import React from "react";
import classNames from "classnames";

interface KbdProps {
  children: React.ReactNode;
  className?: string;
}

export function Kbd({ children, className }: KbdProps) {
  return (
    <kbd
      className={classNames(
        "inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1 text-[10px] font-mono font-semibold leading-none rounded border border-gray-500 bg-gray-700 text-gray-100 shadow-[inset_0_-1px_0_rgba(0,0,0,0.25)]",
        className
      )}
    >
      {children}
    </kbd>
  );
}
